import { createAsyncThunk } from "@reduxjs/toolkit";
import { ShadeMode } from "../state";


export const saveShadeThunk = createAsyncThunk(
  'mode/save',
  async (shade: ShadeMode) => {
    window.localStorage.setItem("mode", (shade === ShadeMode.Light) ? "light" : "dark");
  }
);